(function () {
  'use strict';
  var root = document.getElementById('ttgHsearch');
  if (!root || root.dataset.ttgInit) return;
  root.dataset.ttgInit = '1';
  var input = root.querySelector('#ttgHsearchInput');
  var sugg = root.querySelector('#ttgHsearchSugg');
  var form = root.querySelector('form');
  var english = document.documentElement.lang.indexOf('en') === 0;
  var german = document.documentElement.lang.indexOf('de') === 0;
  var mobile = window.matchMedia('(max-width: 749px)').matches;
  var modes = {
    all: {tag: null, label: german ? 'Alle' : english ? 'All' : 'Tutto', hint: german ? 'Name, Karte oder Produktcode suchen' : english ? 'Search a name, card or product code' : 'Cerca una carta, un prodotto o un codice…'},
    singles: {tag: 'SINGLE', label: german ? 'Einzelkarten' : english ? 'Singles' : 'Singole', hint: german ? 'Einzelkarte suchen' : english ? 'Search single cards' : 'Cerca una carta'},
    order: {tag: 'Ordinabile', label: german ? 'Bestellbar' : english ? 'To order' : 'Ordinabili', hint: german ? 'Bestellbare Produkte suchen' : english ? 'Search products to order' : 'Cerca tra i prodotti ordinabili'},
    sealed: {tag: 'SEALED', label: german ? 'Sealed' : english ? 'Sealed' : 'Sigillati', hint: german ? 'Versiegeltes Produkt suchen' : english ? 'Search sealed products' : 'Cerca un prodotto sealed'}
  };
  var endpoint = new URL(form.action, location.href);
  var params = new URLSearchParams(location.search);
  var onSearch = location.pathname.replace(/\/$/, '') === endpoint.pathname.replace(/\/$/, '');
  var raw = onSearch ? params.get('q') || '' : '';
  var clean = raw.replace(/\s+(?:AND\s+)?tag:(SINGLE|SEALED)\b/gi, '').replace(/^tag:(SINGLE|SEALED)\b\s*/i, '').trim();
  var state = window.TTGSearch;
  var mode = onSearch && state ? state.mode(params) : 'all';
  if (onSearch) input.value = state ? state.text(params) : clean;
  var sort = onSearch && ['relevance', 'price-ascending', 'price-descending'].indexOf(params.get('sort_by')) !== -1 ? params.get('sort_by') : 'relevance';
  var timer, controller, sequence = 0, selected = -1;
  var cache = new Map();
  function searchUrl(q, suggest) {
    var url = new URL(endpoint.href);
    var live = new URLSearchParams(location.search);
    var keep = new URLSearchParams();
    var sameQuery = onSearch && state && state.normalize(q) === state.normalize(state.text(live));
    live.forEach(function (v, k) {
      if ((sameQuery && (k.indexOf('filter.') === 0 || k.indexOf('ttg_') === 0 || k === 'sort_by')) || k === 'preview_theme_id') keep.append(k, v);
    });
    if (!sameQuery) keep.set('sort_by', 'relevance');
    keep = state ? state.build(q, mode, keep) : keep;
    if (!state) { keep.set('q', q + (modes[mode].tag ? ' AND tag:' + modes[mode].tag : '')); keep.set('type','product'); }
    keep.set('sort_by', suggest ? 'relevance' : (keep.get('sort_by') || 'relevance'));
    if (suggest) keep.set('view', 'ttg-suggest');
    url.search = keep.toString();
    if ((english || german) && keep.get('ttg_set')) url.pathname = url.pathname.replace(/^\/(?:en|de)(?=\/)/, '');
    return url.pathname + url.search;
  }
  function close() {
    clearTimeout(timer);
    sequence++;
    if (controller) controller.abort();
    controller = null;
    selected = -1;
    sugg.classList.remove('is-open');
    sugg.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    input.removeAttribute('aria-busy');
  }
  function setMode(next, save) {
    close();
    mode = modes[next] ? next : 'all';
    root.querySelectorAll('[data-mode]').forEach(function (b) {
      var active = b.dataset.mode === mode;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', String(active));
      b.textContent = modes[b.dataset.mode].label;
    });
    root.querySelector('.ttg-hsearch__modes').style.setProperty('--ttg-mode-i', {all: 0, singles: 1, sealed: 2, order: 3}[mode]);
    input.placeholder = mobile && mode !== 'all' ? (german ? 'Suche: ' : english ? 'Search ' : 'Cerca solo ') + modes[mode].label.toLowerCase() : modes[mode].hint;
    if (save) { try { localStorage.setItem('ttg_search_mode', mode); } catch (e) {} }
  }
  function render(products, q, failed, related, total) {
    var ranked = state.rank(products,q);
    var direct = ranked.filter(function(x){return x.s>0;});
    related = products.length>0 && !!related;
    products = ranked.slice(0,8).map(function(x){return x.p;});
    sugg.innerHTML = '';
    selected = -1;
    input.removeAttribute('aria-activedescendant');
    var heading = document.createElement('div'); heading.className = 'ttg-hsearch__heading';
    heading.textContent = related ? (german ? 'Ähnliche Produkte — keine genaue Übereinstimmung' : english ? 'Related products — no exact match' : 'Alternative: nessuna corrispondenza per nome o codice') : (german ? 'Treffer nach Name oder Code' : english ? 'Matches by name or code' : 'Corrispondenze per nome o codice');
    if (!related && direct.length && direct.every(function(x){return x.s<175;})) heading.textContent = german ? 'Teiltreffer im Namen' : english ? 'Partial name matches' : 'Corrispondenze parziali nel nome';
    sugg.appendChild(heading);
    if (!products.length) {
      var empty = document.createElement('div');
      empty.className = 'ttg-hsearch__empty';
      empty.textContent = failed ? (german ? 'Vorschläge nicht verfügbar. Drücke Enter für die Suche.' : english ? 'Suggestions unavailable. Press Enter to search.' : 'Suggerimenti non disponibili. Premi Invio per cercare.') : (german ? 'Keine Vorschläge. Drücke Enter für alle Suchergebnisse.' : english ? 'No suggestions. Press Enter for the full search.' : 'Nessun suggerimento — Invio per la ricerca completa');
      sugg.appendChild(empty);
    }
    products.forEach(function (product, i) {
      var a = document.createElement('a');
      a.className = 'ttg-hsearch__item';
      a.id = 'ttg-suggestion-' + i;
      a.setAttribute('role', 'option');
      a.setAttribute('aria-selected', 'false');
      a.href = product.url;
      if (product.image) {
        var img = document.createElement('img');
        img.src = product.image; img.alt = ''; img.loading = 'lazy'; a.appendChild(img);
      }
      var title = document.createElement('span');
      title.className = 'ttg-hsearch__ititle';
      var name = document.createElement('span'); name.className = 'ttg-hsearch__iname'; name.textContent = product.title; title.appendChild(name);
      if (product.variant) { var meta = document.createElement('small'); meta.className = 'ttg-hsearch__imeta'; meta.textContent = product.variant; title.appendChild(meta); }
      var stock = document.createElement('small'); stock.className = 'ttg-hsearch__imeta';
      stock.textContent = product.orderable ? (german ? 'Bestellbar · nicht im Laden verfügbar' : english ? 'To order · not in store' : 'Ordinabile · non in negozio') : product.available ? (german ? 'Verfügbar' : english ? 'Available' : 'Disponibile') : (german ? 'Ausverkauft' : english ? 'Sold out' : 'Esaurito');
      title.appendChild(stock);
      a.appendChild(title);
      var price = document.createElement('span');
      price.className = 'ttg-hsearch__iprice';
      var personal = product.member_discount === true && Number(product.member_valid_until) * 1000 > Date.now();
      price.textContent = personal || !product.member_discount ? product.price : product.regular_price;
      if (personal) {
        var regular = document.createElement('s');
        regular.className = 'ttg-hsearch__regular'; regular.textContent = product.regular_price;
        price.insertBefore(regular, price.firstChild);
        var benefit = document.createElement('small');
        benefit.className = 'ttg-hsearch__member';
        benefit.textContent = german ? 'Deine Spielerkarte: −5 %' : english ? 'Your membership: −5%' : 'La tua tessera: −5%';
        price.appendChild(benefit);
      }
      a.appendChild(price);
      sugg.appendChild(a);
    });
    var all = document.createElement('a');
    all.className = 'ttg-hsearch__all'; all.id = 'ttg-suggestion-all';
    all.setAttribute('role', 'option'); all.setAttribute('aria-selected', 'false');
    all.href = searchUrl(q, false);
    all.textContent = (german ? 'Alle Ergebnisse für „' : english ? 'All results for “' : 'Tutti i risultati per “') + q + '” →';
    if (related) { var u = new URL(all.href); u.searchParams.set('ttg_match','related'); u.search = state.build(q,mode,u.searchParams).toString(); all.href = u.href; all.textContent = german ? 'Alle ähnlichen Produkte' : english ? 'View related products' : 'Vedi le alternative'; }
    if (!related && Number(total)>0) all.textContent = (german ? 'Alle ' + total + ' Ergebnisse' : english ? 'View all ' + total + ' results' : 'Vedi tutti i ' + total + ' risultati') + ' →';
    sugg.appendChild(all);
    sugg.classList.add('is-open'); input.setAttribute('aria-expanded', 'true');
  }
  function refresh() {
    var q = input.value.trim().replace(/\s+/g, ' ');
    if (q.length < 2) { close(); return; }
    if (controller) controller.abort();
    var ticket = ++sequence;
    var url = searchUrl(q, true);
    if (!sugg.classList.contains('is-open')) { sugg.textContent = german ? 'Suche…' : english ? 'Searching…' : 'Ricerca in corso…'; sugg.classList.add('is-open'); input.setAttribute('aria-expanded','true'); }
    if (cache.has(url) && cache.get(url).until > Date.now()) { input.removeAttribute('aria-busy'); render(cache.get(url).products, q, false, cache.get(url).related, cache.get(url).total); return; }
    cache.delete(url);
    controller = window.AbortController ? new AbortController() : null;
    input.setAttribute('aria-busy', 'true');
    if (new URL(url,location.href).searchParams.get('ttg_index')==='1' && window.TTGContains) {
      window.TTGContains.suggest(q,mode,new URL(url,location.href).searchParams,controller && controller.signal).then(function(data){if(ticket!==sequence)return;input.removeAttribute('aria-busy');render(data.products,q,false,false,data.total);}).catch(function(e){if(ticket!==sequence||e.name==='AbortError')return;input.removeAttribute('aria-busy');render([],q,true);});return;
    }
    fetch(url, controller ? {signal: controller.signal} : {}).then(function (r) {
      if (!r.ok) throw new Error('Search unavailable');
      return r.json();
    }).then(function (data) {
      if (ticket !== sequence) return;
      if (!Array.isArray(data.products)) throw new Error('Invalid suggestions');
      if (cache.size >= 30) cache.delete(cache.keys().next().value);
      if (!data.products.length && new URL(url,location.href).searchParams.get('ttg_match') !== 'related') {
        var broad = new URL(url,location.href); var bp = broad.searchParams; bp.set('ttg_match','related'); bp = state.build(q,mode,bp); bp.set('view','ttg-suggest'); broad.search=bp.toString();
        return fetch(broad.pathname+broad.search,controller ? {signal:controller.signal}:{}).then(function(r){if(!r.ok)throw new Error('Search unavailable');return r.json();}).then(function(alt){if(ticket!==sequence)return;input.removeAttribute('aria-busy');render((Array.isArray(alt.products)?alt.products:[]).filter(function(p){return state.related(p,q);}),q,false,true);});
      }
      var cacheUntil = Date.now() + 30000;
      data.products.forEach(function (p) { if (p.member_discount) cacheUntil = Math.min(cacheUntil, Number(p.member_valid_until) * 1000); });
      cache.set(url, {products: data.products, until: cacheUntil, related: new URL(url,location.href).searchParams.get('ttg_match')==='related', total:data.total});
      input.removeAttribute('aria-busy');
      render(data.products, q, false, new URL(url,location.href).searchParams.get('ttg_match') === 'related', data.total);
    }).catch(function (e) {
      if (ticket !== sequence || e.name === 'AbortError') return;
      input.removeAttribute('aria-busy'); render([], q, true);
    });
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = input.value.trim().replace(/\s+/g, ' ');
    if(q) location.href = searchUrl(q, false); else input.focus();
  });
  root.querySelectorAll('[data-mode]').forEach(function (b) {
    b.addEventListener('click', function () { setMode(b.dataset.mode, true); input.focus(); if (input.value.trim().length >= 2) refresh(); });
  });
  input.addEventListener('input', function () {
    close();
    if (input.value.trim().replace(/\s+/g, ' ').length >= 2) timer = setTimeout(refresh, 250);
  });
  input.addEventListener('focus', function () { if (input.value.trim().replace(/\s+/g, ' ').length >= 2) refresh(); });
  input.addEventListener('keydown', function (e) {
    if (e.isComposing) return;
    var items = sugg.querySelectorAll('[role="option"]');
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Enter') {
      if (selected >= 0 && items[selected]) { e.preventDefault(); location.href = items[selected].href; }
      return;
    }
    if (!items.length || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
    e.preventDefault();
    selected = (selected + (e.key === 'ArrowDown' ? 1 : (selected < 0 ? 0 : -1)) + items.length) % items.length;
    items.forEach(function (el, i) { el.classList.toggle('is-sel', i === selected); el.setAttribute('aria-selected', String(i === selected)); });
    input.setAttribute('aria-activedescendant', items[selected].id);
    items[selected].scrollIntoView({block: 'nearest'});
  });
  document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
  root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) close(); });
  var filterLink = root.querySelector('.ttg-hsearch__filter-link') || document.createElement('a');
  filterLink.className = 'ttg-hsearch__filter-link';
  filterLink.textContent = german ? 'Spiel, Erweiterung und weitere Filter' : english ? 'Game, expansion and advanced filters' : 'Gioco, espansione e filtri avanzati';
  filterLink.href = searchUrl(input.value.trim(), false) + '#ttgCatalog';
  filterLink.addEventListener('click', function () { filterLink.href = searchUrl(input.value.trim(), false) + '#ttgCatalog'; });
  if (!filterLink.parentNode) root.appendChild(filterLink);
  document.addEventListener('ttg:filters-updated', function () { var edited = state && input.value.trim() !== state.text(params); params = new URLSearchParams(location.search); if (!edited && state) { close(); input.value = state.text(params); setMode(state.mode(params), false); } });
  window.matchMedia('(max-width: 749px)').addEventListener('change', function (e) { mobile = e.matches; setMode(mode, false); });
  setMode(mode, false);
})();
